import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import "./SpeakerCard.css";

const SpeakerCard = ({ speaker, onClick, isExpanded }) => {
  const [imgError, setImgError] = useState(false);

  // Safe extraction of initials
  const getInitials = (name) => {
    if (!name) return "SP";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const imageUrl = speaker.avatar_url || speaker.photo;

  return (
    <div
      className={`speaker-card ${isExpanded ? "expanded" : ""}`}
      onClick={onClick}
    >
      {/* 1. Avatar Section */}
      <div className="speaker-avatar">
        {imageUrl && !imgError ? (
          <img
            src={imageUrl}
            alt={speaker.name}
            onError={() => setImgError(true)}
          />
        ) : (
          <span>{getInitials(speaker.name)}</span>
        )}
      </div>

      {/* 2. Info Section (The text part) */}
      <div className="speaker-info">
        <h3 className="speaker-name">{speaker.name}</h3>
        <div className="speaker-role">
          <span className="speaker-title">{speaker.title || "Speaker"}</span>
          {speaker.organization && (
            <span className="speaker-org">{speaker.organization}</span>
          )}
        </div>
      </div>

      {/* 3. Arrow Section */}
      <div className={`speaker-arrow ${isExpanded ? "rotated" : ""}`}>
        <ChevronRight size={20} />
      </div>
    </div>
  );
};

export default SpeakerCard;
